import { render, staticRenderFns } from "./ReferencesPreviewTable.vue?vue&type=template&id=307e4dbc&scoped=true&"
import script from "./ReferencesPreviewTable.vue?vue&type=script&lang=js&"
export * from "./ReferencesPreviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307e4dbc",
  null
  
)

export default component.exports